"use strict";
import React from "react";
var ButtonColor = /* @__PURE__ */ ((ButtonColor2) => {
  ButtonColor2["Primary"] = "primary";
  ButtonColor2["Destruct"] = "destruct";
  return ButtonColor2;
})(ButtonColor || {});
var ButtonSize = /* @__PURE__ */ ((ButtonSize2) => {
  ButtonSize2["Large"] = "large";
  ButtonSize2["Medium"] = "medium";
  ButtonSize2["Small"] = "small";
  return ButtonSize2;
})(ButtonSize || {});
var ButtonVariant = /* @__PURE__ */ ((ButtonVariant2) => {
  ButtonVariant2["Filled"] = "filled";
  ButtonVariant2["Outlined"] = "outlined";
  ButtonVariant2["Text"] = "text";
  return ButtonVariant2;
})(ButtonVariant || {});
class Button extends React.Component {
  render() {
    const classes = [
      "v3__button",
      `v3__button--color-${this.props.color || "primary" /* Primary */}`,
      `v3__button--size-${this.props.size || "large" /* Large */}`,
      `v3__button--variant-${this.props.variant || "filled" /* Filled */}`
    ];
    if (this.props.disabled) {
      classes.push("v3__button--disabled");
    }
    if (this.props.href) {
      return /* @__PURE__ */ React.createElement(
        "a",
        {
          href: this.props.href,
          target: this.props.target,
          className: classes.join(" "),
          onClick: this.props.onClick,
          key: this.props.key,
          style: this.props.style
        },
        /* @__PURE__ */ React.createElement("span", { className: "v3__button--label-wrapper" }, this.props.children)
      );
    } else {
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          className: classes.join(" "),
          onClick: this.props.onClick,
          key: this.props.key,
          style: this.props.style
        },
        /* @__PURE__ */ React.createElement("span", { className: "v3__button--label-wrapper" }, this.props.children)
      );
    }
  }
}
export { Button, ButtonSize, ButtonVariant };
